<template>
  <div id="course">
    <div class="page-title-wrapper" aria-label="Page title">
      <div class="container edutainer">
        <div
          class="jumbotron bg-size-cover bg-position-center bg-no-repeat text-center"
          style="
            background-image: url(https://openstudio.nl/media/uploads/edu/open-studio-blackmagic-design-cursus-davinci-resolve-edit.png)
              /*,linear-gradient(314deg, #feb07b 0%, #521233 51%, #211f44 100%)*/;
          "
        >
          <div class="row">
            <div class="col-xl-6 col-lg-4">
              <h1 class="text-left display-4 /*text-light*/">
                <small class="cursus">Cursus</small> Davinci Resolve
                <span class="topic">Editing</span>
              </h1>
              <p class="text-left lead /*text-light*/">
                This is a simple hero unit, a simple jumbotron-style component
                for calling extra attention to featured content or information.
              </p>
              <hr class="my-4 hr-light" />
              <a
                class="btn btn-success rounded"
                role="button"
                href="#inschrijven"
                >Start data</a
              >
            </div>
            <!--end col text-->
            <div class="col-xl-6 col-lg-4"></div>
            <!--end col blank-->
          </div>
          <!--end row-->
        </div>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="mt-n1 mr-1"><i data-feather="home"></i></li>
            <li class="breadcrumb-item"><a href="index.html">Home</a></li>
            <li class="breadcrumb-item">
              <a href="help-topics.html">Help center</a>
            </li>
          </ol>
        </nav>
        <!--h1.page-title !{pageTitle}-->
        <!--span.d-block.mt-2.text-muted !{pageSubTitle}-->
        <hr class="mt-4" />
      </div>
    </div>
    <!-- Page Content-->
    <div class="container pb-5 mb-2">
      <div class="row">
        <div class="col-xl-9 col-lg-8">
          <p class="lead">
            Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum. Sed ut perspiciatis unde omnis iste natus error
            sit voluptatem accusantium doloremque laudantium, totam rem aperiam,
            eaque ipsa quae ab illo inventore.
          </p>
          <!-- Basic blockquote -->
          <blockquote class="blockquote">
            <p class="mb-0">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
              posuere erat a ante. Faucibus porta lacus fringilla vel porta
              lacus fringilla.
            </p>
            <footer class="blockquote-footer">
              Someone famous in <cite title="Source Title">Source Title</cite>
            </footer>
          </blockquote>

          <div class="row" id="programma">
            <div class="col-md-12">
              <!-- Featured products -->
              <div class="widget widget-featured-entries">
                <h3 class="widget-title">Programma</h3>
              </div>
              <!--end widget title inschrijven-->
            </div>
            <!--en col 12-->
          </div>
          <!--end row title-->
          <div class="row pt-3 mb-md-3">
            <div class="col-md-12">
              <div v-for="program in programs" :key="program.id">
                <div :key="item.id" v-for="item in program.items">
                  <h2 class="h4 pb-3">{{ item.name }}</h2>
                  <p class="" v-html="item.description">
                  </p>
                  <hr class="mt-4 mb-4" />
                </div>
              </div>
            </div>
            <!--end left col 7 inschrijving-->
          </div>
          <!--end row inschrijving-->

          <div class="row" id="faq">
            <div class="col-md-12">
              <!-- Featured products -->
              <div class="widget widget-featured-entries">
                <h3 class="widget-title">Veelgestelde vragen</h3>
              </div>
              <!--end widget title inschrijven-->
            </div>
            <!--en col 12-->
          </div>
          <!--end row title-->
          <div class="row pt-3 mb-md-3">
            <div class="col-md-12">
              <h2 class="h4 pb-3">Krijgen je ook boeken?</h2>
              <p class="">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo.
              </p>
              <hr class="mt-4 mb-4" />
              <h2 class="h4 pb-3">Krijgen je ook boeken?</h2>
              <p class="">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo.
              </p>
              <hr class="mt-4 mb-4" />
              <h2 class="h4 pb-3">Krijgen je ook boeken?</h2>
              <p class="">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo.
              </p>
              <hr class="mt-4 mb-4" />
              <h2 class="h4 pb-3">Krijgen je ook boeken?</h2>
              <p class="">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo.
              </p>
              <hr class="mt-4" />
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
        <!--end col-9-->
        <div class="col-xl-3 col-lg-4">
          <!-- Related articles sidebar-->
          <div class="" id="inschrijven">
            <!--side sign up-->
            <h3 class="widget-title">Start Data</h3>

            <!-- Actionable list group inside card -->
            <div class="card mb-4">
              <div class="card-body">
                <div class="icon-box d-flex align-items-center text-center">
                  <div class="icon-box-icon my-4 mr-3">
                    <i data-feather="calendar"></i>
                  </div>
                  <!--end icon-->
                  <div class="icon-box-body">
                    <h3 class="h4 icon-box-title text-left">
                      Start woensdag 24 januari
                      <small class="text-muted">2024</small>
                    </h3>
                  </div>
                  <!--end iconbox body-->
                </div>
                <!--end icon box-->
                <!--<h5 class="card-title">Card title</h5>-->
                <p class="card-text font-size-sm text-muted">
                  2 dagen per week, woensdag en donderdag. De Cursus start om
                  10.00 tot 16.30.
                </p>
              </div>
              <div class="list-group list-group-flush">
                <span class="list-group-item list-group-item-action active"
                  ><i
                    class="text-success mr-2"
                    data-feather="calendar"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span></span>36 lesdagen</span
                >
                <span class="list-group-item list-group-item-action"
                  ><i
                    class="text-warning mr-2"
                    data-feather="x"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span>Vakanties: 01-03-2024 Herfstvakantie</span></span
                >
                <span class="list-group-item list-group-item-action"
                  ><i
                    class="text-success mr-2"
                    data-feather="check"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span>Elke maandag &amp; dinsdag</span></span
                >
                <span class="list-group-item list-group-item-action"
                  ><i
                    class="text-success mr-2"
                    data-feather="shopping-bag"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span>&euro; 1000</span></span
                >
              </div>
              <div class="card-body">
                <a class="btn btn-outline-success btn-block">
                  Schrijf je nu in
                </a>
              </div>
            </div>
            <!--end date card sign up-->

            <!-- Actionable list group inside card -->
            <div class="card mb-4">
              <div class="card-body">
                <div class="icon-box d-flex align-items-center text-center">
                  <div class="icon-box-icon my-4 mr-3">
                    <i data-feather="calendar"></i>
                  </div>
                  <!--end icon-->
                  <div class="icon-box-body">
                    <h3 class="h4 icon-box-title text-left">
                      Start woensdag 24 januari
                      <small class="text-muted">2024</small>
                    </h3>
                  </div>
                  <!--end iconbox body-->
                </div>
                <!--end icon box-->
                <!--<h5 class="card-title">Card title</h5>-->
                <p class="card-text font-size-sm text-muted">
                  2 dagen per week, woensdag en donderdag. De Cursus start om
                  10.00 tot 16.30.
                </p>
              </div>
              <div class="list-group list-group-flush">
                <span class="list-group-item list-group-item-action active"
                  ><i
                    class="text-success mr-2"
                    data-feather="calendar"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span></span>36 lesdagen</span
                >
                <span class="list-group-item list-group-item-action"
                  ><i
                    class="text-warning mr-2"
                    data-feather="x"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span>Vakanties: 01-03-2024 Herfstvakantie</span></span
                >
                <span class="list-group-item list-group-item-action"
                  ><i
                    class="text-success mr-2"
                    data-feather="check"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span>Elke maandag &amp; dinsdag</span></span
                >
                <span class="list-group-item list-group-item-action"
                  ><i
                    class="text-success mr-2"
                    data-feather="shopping-bag"
                    style="width: 1rem; height: 1rem"
                  ></i
                  ><span>&euro; 1000</span></span
                >
              </div>
              <div class="card-body">
                <a class="btn btn-outline-success btn-block">
                  Schrijf je nu in
                </a>
              </div>
            </div>
            <!--end date card sign up-->
            <!--side nav-->
            <div class="widget widget-links">
              <h3 class="widget-title">Gerelateerde Software Cursussen</h3>
              <ul>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Adobe Premiere Pro</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Avid Media Composer</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Davinci Resolve Kleurcorrectie</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Davinci Resolve Pakket</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Adobe After Effects</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Final Cut Pro X</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Adobe Indesign</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><i
                      class="widget-categories-indicator"
                      data-feather="chevron-right"
                    ></i
                    >Adobe Illustrator</a
                  >
                </li>
              </ul>
              <a
                class="btn btn-outline-dark rounded mb-2"
                role="button"
                href="/opleidinge/"
                >&larr; Overzicht alle cursussen</a
              >
              <a
                class="btn btn-outline-danger rounded"
                role="button"
                href="/agenda/"
                >Agenda</a
              >
            </div>
            <!--infodag-->
            <a
              href="/inloopdagen/"
              ng-show="ctrl.items.items"
              class="d-block text-decoration-0 mt-4"
              ><div class="bg-secondary">
                <div class="px-3 pt-4 text-center">
                  <h4 class="font-size-sm font-weight-normal pt-1 mb-2">
                    Aankomende
                  </h4>
                  <h4 class="h5 pb-2">Infodag</h4>
                  <div class="btn btn-primary btn-sm mb-3">
                    Meld je aan voor de Infodag
                  </div>
                </div>
                <div data-v-db36f0d0="" class="row">
                  <div data-v-db36f0d0="" class="col-md-12">
                    <div data-v-db36f0d0="" ng-editor="main-block"></div>
                    <table
                      data-v-db36f0d0=""
                      class="table table-vcenter table-hover table-striped"
                    >
                      <thead data-v-db36f0d0="">
                        <tr data-v-db36f0d0="">
                          <th data-v-db36f0d0="">Datum</th>
                          <th data-v-db36f0d0="">Tijd</th>
                          <th data-v-db36f0d0="">Locatie</th>
                        </tr>
                      </thead>
                      <tbody data-v-db36f0d0="">
                        <tr data-v-db36f0d0="">
                          <td data-v-db36f0d0="">
                            <i
                              data-v-db36f0d0=""
                              class="fa fa-fw fa-calendar-o text-primary"
                            ></i
                            ><span data-v-db36f0d0="" class="small">
                              05-04 </span
                            ><!----><!---->
                          </td>
                          <td data-v-db36f0d0="">
                            <i
                              data-v-db36f0d0=""
                              class="fa fa-fw fa-clock-o text-primary"
                            ></i
                            ><span data-v-db36f0d0="" class="small">
                              12.00
                            </span>
                          </td>
                          <td data-v-db36f0d0="">
                            <a data-v-db36f0d0="" href="/inloopdagen/#register"
                              ><span data-v-db36f0d0="" class="small">
                                Amsterdam</span
                              ></a
                            >
                          </td>
                        </tr>
                        <tr data-v-db36f0d0="">
                          <td data-v-db36f0d0="">
                            <i
                              data-v-db36f0d0=""
                              class="fa fa-fw fa-calendar-o text-primary"
                            ></i
                            ><span data-v-db36f0d0="" class="small">
                              17-04 </span
                            ><!----><!---->
                          </td>
                          <td data-v-db36f0d0="">
                            <i
                              data-v-db36f0d0=""
                              class="fa fa-fw fa-clock-o text-primary"
                            ></i
                            ><span data-v-db36f0d0="" class="small">
                              12.00
                            </span>
                          </td>
                          <td data-v-db36f0d0="">
                            <a data-v-db36f0d0="" href="/inloopdagen/#register"
                              ><span data-v-db36f0d0="" class="small">
                                Amsterdam</span
                              ></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div></a
            >
            <!--end infodag-->
          </div>
        </div>
        <!-- Submit request-->
        <!-- Split section: Map + Contact form-->
        <div
          class="container-fluid px-0 pt-4 pt-lg-5"
          id="map"
          data-offset-top="30"
        >
          <div class="row no-gutters">
            <div class="col-lg-6 iframe-full-height-wrap">
              <iframe
                class="iframe-full-height"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4876.102342986735!2d4.915668876617351!3d52.33321777201281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c60bcd8171e147%3A0x47b96c248c475155!2sOpen%20Studio!5e0!3m2!1sen!2snl!4v1711106086608!5m2!1sen!2snl"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div class="col-lg-6 px-4 px-xl-5 py-5 border-top">
              <h2 class="h4 mb-4">Plan een adviesgesprek in</h2>
              <p></p>
              <form class="needs-validation mb-3" novalidate>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="cf-name"
                        >Je naam:&nbsp;<span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        id="cf-name"
                        placeholder="John Doe"
                        required
                      />
                      <div class="invalid-feedback">
                        Please fill in you name!
                      </div>
                    </div>
                  </div>
                </div>
                <!--end row-->
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="cf-email"
                        >Emailadres:&nbsp;<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <input
                        class="form-control"
                        type="email"
                        id="cf-email"
                        placeholder="johndoe@email.com"
                        required
                      />
                      <div class="invalid-feedback">
                        Please provide valid email address!
                      </div>
                    </div>
                  </div>
                </div>
                <!--end row-->
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="cf-phone"
                        >Telefoonnummer:&nbsp;<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        id="cf-phone"
                        placeholder="06 12 34 56 78"
                        required
                      />
                      <div class="invalid-feedback">
                        Please provide valid phone number!
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="cf-message"
                    >Stel hier je vraag:&nbsp;<span class="text-danger"
                      >*</span
                    ></label
                  >
                  <textarea
                    class="form-control"
                    id="cf-message"
                    rows="6"
                    placeholder="Je ontvangt binnen een werkdag bericht"
                    required
                  ></textarea>
                  <div class="invalid-feedback">Please write a message!</div>
                </div>
                <a class="btn btn-outline-success btn-block"> Verstuur </a>
              </form>
            </div>
          </div>
          <div class="text-center pt-5 mt-2">
            <h4 class="pb-3">
              Niet gevonden wat je zocht? Laat ons je helpen.
            </h4>
            <div class="mb-2">
              <div class="icon-box-icon"><i data-feather="life-buoy"></i></div>
            </div>
            <button
              type="button"
              class="btn btn-outline-primary"
              href="/contact/"
            >
              Mail ons
            </button>
            <button
              type="button"
              class="btn btn-outline-success"
              href="tel:+31205246060"
            >
              020 524 6060
            </button>
            <p class="pt-4">
              We zijn <mark>maandag tot en met vrijdag</mark> tussen
              <mark>09:00 en 17:00</mark>
              <a href="tel:+31205246060">telefonisch</a> bereikbaar.
            </p>
            <p>Op e-mails zullen we zo snel mogelijk reageren.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.os-header-img-container {
  min-height: 330px;
  max-height: 400px;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-size: 100% auto;
}
</style>

<script>
import axios from "axios";
import { pageStore } from "@/stores/page";
// import OpenDoorDayWidget from "@/components/OpenDoorDayWidget.vue";
// import EditableBlock from "@/components/EditableBlock.vue";

export default {
  name: "CourseView2EditableBlock",
  components: {
    // OpenDoorDayWidget,
    // EditableBlock,
  },
  filters: {
    toFloat: function (value) {
      return parseFloat(value);
    },
  },
  data: function () {
    return {
      course: {},
      runs: [],
      programs: [],
      blocks: new Map(),
    };
  },
  created() {
    // watch the params of the route to fetch the data again
    this.$watch(
      () => this.$route.params,
      () => {
        this.fetchData();
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
  },
  computed: {
    cursus_vragen() {
      if (
        this.page_store.widgets &&
        this.page_store.widgets.get("cursus-vragen")
      ) {
        return this.page_store.widgets.get("cursus-vragen").content;
      }
      return "";
    },
  },
  methods: {
    fetchData() {
      var vue = this;
      axios
        .get("/api/courses/" + this.$route.params.slug + "/")
        .then((response) => {
          this.course = response.data;
          axios
            .get("/api/main/internalpages/" + this.course.page.id + "/")
            .then((response) => {
              this.blocks = new Map(
                response.data.blocks.map(function (b) {
                  return [b.name, b];
                })
              );
            });
        });
      var params = {
        params: {
          courses__slug: this.$route.params.slug,
          no_page: true,
        },
      };
      axios
        .get("/api/programs/", params)
        .then((response) => (this.programs = response.data));
      params = {
        params: {
          course__slug: this.$route.params.slug,
          no_page: true,
        },
      };
      axios.get("/api/runs/", params).then((response) => {
        this.runs = response.data;
        this.runs.forEach((run) => {
          run.shortDates = run.dates
            .map(function (d) {
              return vue.moment(d.date).format("DD/MM");
            })
            .join(", ");
        });
      });
    },
  },
  setup() {
    const page_store = pageStore();
    return {
      page_store,
    };
  },
};
</script>
